<ng-template #modal>
  <div
    class="modal-container"
    [ngClass]="{ 'modal-container--solid-bg': isSolidModalBg }"
  >
    <div id="spin">
      <svg
        width="76px"
        height="76px"
        viewBox="0 0 76 76"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="loading"
          transform="translate(38.000000, 38.000000) rotate(-180.000000) translate(-38.000000, -38.000000) translate(3.000000, 3.000000)"
        >
          <g
            id="group"
            style="fill: var(--brandDark)"
            transform="translate(1.400000, 0.000000)"
          >
            <circle
              id="Oval-1"
              transform="translate(14.114261, 56.873928) rotate(180.000000) translate(-14.114261, -56.873928) "
              cx="14.1142611"
              cy="56.8739279"
              r="4.9122807"
            ></circle>
            <circle
              id="Oval-2"
              transform="translate(55.760557, 15.230626) rotate(180.000000) translate(-55.760557, -15.230626) "
              cx="55.7605573"
              cy="15.2306264"
              r="7.36842105"
            ></circle>
            <circle
              id="Oval-3"
              transform="translate(14.287936, 15.390205) rotate(270.000000) translate(-14.287936, -15.390205) "
              cx="14.2879364"
              cy="15.3902047"
              r="6.14035088"
            ></circle>
            <circle
              id="Oval-4"
              transform="translate(55.622670, 56.675567) rotate(270.000000) translate(-55.622670, -56.675567) "
              cx="55.6226697"
              cy="56.6755671"
              r="3.68421053"
            ></circle>
            <circle
              id="Oval-5"
              transform="translate(35.000000, 65.701754) rotate(180.000000) translate(-35.000000, -65.701754) "
              cx="35"
              cy="65.7017544"
              r="4.29824561"
            ></circle>
            <circle
              id="Oval-6"
              transform="translate(35.000000, 6.754386) rotate(180.000000) translate(-35.000000, -6.754386) "
              cx="35"
              cy="6.75438596"
              r="6.75438596"
            ></circle>
            <circle
              id="Oval-7"
              transform="translate(5.526316, 36.228070) rotate(270.000000) translate(-5.526316, -36.228070) "
              cx="5.52631579"
              cy="36.2280702"
              r="5.52631579"
            ></circle>
            <circle
              id="Oval-8"
              transform="translate(64.473684, 36.228070) rotate(270.000000) translate(-64.473684, -36.228070) "
              cx="64.4736842"
              cy="36.2280702"
              r="3.07017544"
            ></circle>
          </g>
        </g>
      </svg>
    </div>
  </div>
</ng-template>
